import { ComboBox, DefaultButton, DialogFooter, Icon, IconButton, IPersonaProps, IPickerItemProps, IStackTokens, ISuggestionItemProps, ISuggestionModel, ISuggestionsProps, ITag, Label, MessageBar, MessageBarType, Modal, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, PrimaryButton, Spinner, SpinnerSize, Stack, TagItemSuggestion, TagPicker, Text, TextField, Toggle, TooltipHost, ValidationState } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks";
import { add, dismissMessage, get, getCurrencies, getLimitations, reset, resetCurrencies, resetLimitations, resetTreasuryTypes, setSelectedTreasuryTypeItems, setIsFilteredTreasuryTypesSet, setIsFilteredCurrenciesSet, getTreasuryTypes, setSelectedCurrencyItems, setIsFilteredLimitationsSet, setSelectedLimitationItems, setStage1, update } from "./TreasuriesFormSlice";
import * as Yup from 'yup';
import { DynamicInputField, InputField } from "../../controls/Controls";
import { inputs } from "../../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../app/Api";
import { Message } from "../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../FormProps";
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatDate, timestampToDate } from "../../../../app/Helpers";
import { AuthenticateReply } from "../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../common/DynamicFields/DynamicFields";
import { ExtraField } from "../../../../repository/Accountant/common_pb";
import { TableState } from "../../../common/Table/TableSate";
import { TreasuryStatus, LimitationType, Operations } from "../../../../app/Enums";
import { GetCurrenciesRequest } from "../../../../repository/Accountant/currency_pb"
import { GetUsersRequest } from "../../../../repository/UserManagement/Customers/user_pb"
import { GetLimitationsRequest } from "../../../../repository/Accountant/limitation_pb"
import { AddTreasuryRequest, AddTreasuryResponse, GetTreasuryRequest, UpdateTreasuryRequest, UpdateTreasuryResponse } from "../../../../repository/Accountant/treasury_pb";
import { GetTreasuryTypesRequest, GetTreasuryTypesResponse } from "../../../../repository/Accountant/treasury_type_pb";
import { List } from "../../../common/List/List";
import { Popup } from "../../../common/Popup/Popup";
import { TreasuryTypesPage } from "../../../pages/Accountant/TreasuryTypes/TreasuryTypesPage";
import { LimitationsPage } from "../../../pages/Accountant/Limitations/LimitationsPage";

let req: AddTreasuryRequest;
let updateReq: UpdateTreasuryRequest;
let limitationReq: GetLimitationsRequest;
let treasuryTypesReq: GetTreasuryTypesRequest;
let currenciesReq: GetCurrenciesRequest;

let promise: any;
let getFilterPromise: any;
let org: number = -1;
let current: AuthenticateReply.AsObject;

export const TreasuriesForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();

    const [currentAction, setCurrenctAction] = useState(0)

    const state: { isLoading: boolean, message: ApiMessage | undefined, stage1: any, limitations: TableState, currencies: TableState, treasuryTypes: TableState } = useAppSelector((state) => {

        return {
            isLoading: state.treasuriesForm.isLoading, message: state.treasuriesForm.message, stage1: state.treasuriesForm.stage1,
            treasuryTypes: state.treasuriesForm.treasuryTypes,
            currencies: state.treasuriesForm.currencies,
            limitations: state.treasuriesForm.limitations,

        }
    })

    useEffect(() => {
        var l = searchParams.get('org');
        req = new AddTreasuryRequest();
        updateReq = new UpdateTreasuryRequest()
        treasuryTypesReq = new GetTreasuryTypesRequest();
        currenciesReq = new GetCurrenciesRequest();
        limitationReq = new GetLimitationsRequest();

        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
                treasuryTypesReq.setOrganization(wrapper)
                currenciesReq.setOrganization(wrapper)
                limitationReq.setOrganization(wrapper)

            }
        }

        if (props.type == FormType.EDIT) {
            if (props.fetchData) {
                let r = new GetTreasuryRequest()
                r.setId(props?.renderObject?.internalId);
                promise?.abort()
                promise = dispatch(get({ body: r, headers: getHeaders() }))
            } else {
                dispatch(setStage1(props?.renderObject))
            }
        }
        const boolv = new BoolValue();
        boolv.setValue(true);
        treasuryTypesReq.setNumofresults(state.treasuryTypes.numberOfResults)
        treasuryTypesReq.setOrder(state.treasuryTypes.isDescending)
        treasuryTypesReq.setIsavailable(boolv)
        currenciesReq.setNumofresults(state.currencies.numberOfResults)
        currenciesReq.setOrder(state.currencies.isDescending)
        currenciesReq.setIsavailable(boolv)
        limitationReq.setNumofresults(state.limitations.numberOfResults)
        limitationReq.setOrder(state.limitations.isDescending)
        const type = new Int32Value();
        type.setValue(LimitationType.TREASURY_LIMITATION);
        limitationReq.setType(type)
        limitationReq.setIsavailable(boolv)


        if (props.renderObject?.currencyId)
            dispatch(setSelectedCurrencyItems(([{ id: props.renderObject.currencyId, name: props.renderObject.currencyName }])))

        if (props.renderObject?.treasuryTypeId)
            dispatch(setSelectedTreasuryTypeItems(([{ id: props.renderObject.treasuryTypeId, name: props.renderObject.treasuryTypeName }])))

        if (props.renderObject?.limitationId)
            dispatch(setSelectedLimitationItems(([{ id: props.renderObject.limitationId, name: props.renderObject.limitationName }])))


        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            dispatch(reset());
        }
    }, [])


    const treasuryTypesSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('treasuryTypes'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.treasuryTypes.hasMore && !state.treasuryTypes.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.treasuryTypes.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedTreasuryTypeItems([state.treasuryTypes.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.treasuryTypes.items.length > 0 && !state.treasuryTypes.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.treasuryTypes.items.at(state.treasuryTypes.items.length - 1).id);
                treasuryTypesReq.setNextto(wrapper)
                getFilterPromise = dispatch(getTreasuryTypes({ body: treasuryTypesReq, headers: getHeaders() }))
            }
        },
        suggestions: state.treasuryTypes.items.length > 0 ? state.treasuryTypes.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.treasuryTypes.items.length == 0 ? state.treasuryTypes.isFetching : false,
        isSearching: state.treasuryTypes.items.length > 0 ? state.treasuryTypes.isFetching : false,


    };
    const onTreasuryTypesFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetTreasuryTypes())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        treasuryTypesReq.setSearch(wrapper)
        treasuryTypesReq.setNextto(undefined)
        dispatch(setIsFilteredTreasuryTypesSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getTreasuryTypes({ body: treasuryTypesReq, headers: getHeaders() }))
        return [];

    }





    const currenciesSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('currencies'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.currencies.hasMore && !state.currencies.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.currencies.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedCurrencyItems([state.currencies.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.currencies.items.length > 0 && !state.currencies.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.currencies.items.at(state.currencies.items.length - 1).id);
                currenciesReq.setNextto(wrapper)
                getFilterPromise = dispatch(getCurrencies({ body: currenciesReq, headers: getHeaders() }))
            }
        },
        suggestions: state.currencies.items.length > 0 ? state.currencies.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.currencies.items.length == 0 ? state.currencies.isFetching : false,
        isSearching: state.currencies.items.length > 0 ? state.currencies.isFetching : false,


    };
    const onCurrenciesFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetCurrencies())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        currenciesReq.setSearch(wrapper)
        currenciesReq.setNextto(undefined)
        dispatch(setIsFilteredCurrenciesSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getCurrencies({ body: currenciesReq, headers: getHeaders() }))
        return [];

    }


    const limitationsSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('limitations'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.limitations.hasMore && !state.limitations.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.limitations.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedLimitationItems([state.limitations.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.limitations.items.length > 0 && !state.limitations.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.limitations.items.at(state.limitations.items.length - 1).id);
                limitationReq.setNextto(wrapper)
                getFilterPromise = dispatch(getLimitations({ body: limitationReq, headers: getHeaders() }))
            }
        },
        suggestions: state.limitations.items.length > 0 ? state.limitations.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.limitations.items.length == 0 ? state.limitations.isFetching : false,
        isSearching: state.limitations.items.length > 0 ? state.limitations.isFetching : false,


    };
    const onLimitationsFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetLimitations())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        limitationReq.setSearch(wrapper)
        limitationReq.setNextto(undefined)
        dispatch(setIsFilteredLimitationsSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getLimitations({ body: limitationReq, headers: getHeaders() }))
        return [];

    }


    return (
        <>
            <Popup isOpen={(currentAction == 100)} title={t("treasuryTypes")} onDismiss={() => { setCurrenctAction(0) }} >

                <TreasuryTypesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedTreasuryTypeItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 101)} title={t("limitations")} onDismiss={() => { setCurrenctAction(0) }} >

                <LimitationsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedLimitationItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Formik
                enableReinitialize={true}
                initialValues={{
                    name: (props.renderObject?.name) ? props.renderObject?.name : "",
                    code: (props.renderObject?.code) ? props.renderObject?.code : "",
                    treasury: undefined,
                    limitation: undefined,
                    nature: (props.renderObject?.nature) ? { key: props.renderObject?.nature, text: "" } : { key: 1, text: t("physical") },
                    extraFields: (state.stage1?.extraFields) ? state.stage1?.extraFields as DynamicField[] : [] as DynamicField[],

                }}

                validationSchema={Yup.object({
                    name: inputs.treasuryName,
                    code: inputs.treasuryCode,

                    extraFields: inputs.extraFields,

                })}

                onSubmit={(values, actions) => {
                    if (props.type == FormType.ADD) {

                        let treasuryTypes = state.treasuryTypes.selected.at(0);
                        let limitations = state.limitations.selected.at(0);

                        req.setTreasurytype(treasuryTypes?.id);
                        req.setLimitation(limitations?.id);
                        req.setCode(values.code?.trim())
                        req.setName(values.name?.trim())
                        req.setNature(Number(values.nature.key))

                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        req.setExtrafieldsList(extraField)
                        promise = dispatch(add({ body: req, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: AddTreasuryResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            id: res.success?.id,
                                            internalId: res.success?.internalid,
                                            name: values.name,
                                            code: values.code,
                                            nature: values.nature.key,
                                            treasuryTypeId: treasuryTypes.id,
                                            treasuryTypeName: treasuryTypes.name,
                                            status: TreasuryStatus.ACTIVE,
                                            limitationId: limitations?.id,
                                            limitationName: limitations?.name,
                                            createdDate: formatDate(timestampToDate(res.success?.createddate?.seconds, res.success?.createddate?.nanos)),
                                            addedBy: (current.profile?.firstname?.value ?? "") + " " + (current.profile?.lastname?.value ?? ""),
                                            addedById: current.profile?.id?.value,
                                            extraFields: [] as DynamicField[],
                                            deposits: [] as any
                                        });
                                    }
                                }
                                actions.setSubmitting(false)


                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    } else {
                        updateReq.setId(props.renderObject?.internalId);
                        updateReq.setCode(values.code)
                        updateReq.setName(values.name)
                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        updateReq.setExtrafieldsList(extraField)
                        promise = dispatch(update({ body: updateReq, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: UpdateTreasuryResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            ...props.renderObject,
                                            name: values.name,
                                            code: values.code,
                                            extraFields: values.extraFields
                                        });
                                    }
                                }
                                actions.setSubmitting(false)
                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    }
                }}

            >
                {formkikProps => (
                    <Form >
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }
                            <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: props.childrenGap }}>
                                <Stack.Item grow>
                                    <Field name="name" label={t("treasuryName")} placeholder={t("treasuryNameHint")} component={InputField} disabled={state.isLoading} autoFocus required maxLength={50} />
                                </Stack.Item>
                                <Stack.Item grow>
                                    <Field name="code" label={t("treasuryCode")} placeholder={"T-01"} component={InputField} disabled={state.isLoading} maxLength={20} />
                                </Stack.Item>

                            </Stack>


                            {props.type == FormType.ADD ? <ComboBox
                                label={t("nature")}
                                required
                                allowFreeform={true}
                                autoComplete={'on'}
                                disabled={state.isLoading}
                                options={[{ key: 1, text: t("physical") }, { key: 2, text: t("virtual") },]}
                                selectedKey={formkikProps.values.nature.key}
                                onChange={(e, o) => {
                                    formkikProps.setFieldValue("nature", { key: o?.key, text: o?.text })
                                }} />
                                : undefined}

                            {props.type == FormType.ADD ? <Stack>
                                <Label required disabled={state.isLoading}>{t("treasuryType")}</Label>
                                <List
                                    inputProps={{ placeholder: t("treasuryType"), required: true }}
                                    disabled={state.isLoading}
                                    suggestionsHeaderText={t('treasuryTypes')}
                                    isLoading={state.treasuryTypes.items.length == 0 ? state.treasuryTypes.isFetching : false}
                                    isSearching={state.treasuryTypes.items.length > 0 ? state.treasuryTypes.isFetching : false}
                                    moreSuggestionsAvailable={state.treasuryTypes.hasMore && !state.treasuryTypes.isFetching}
                                    suggestions={state.treasuryTypes.items.length > 0 ? state.treasuryTypes.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                    onGetMoreResults={() => {
                                        if (state.treasuryTypes.items.length > 0 && !state.treasuryTypes.isFetching) {
                                            const wrapper = new StringValue();
                                            wrapper.setValue(state.treasuryTypes.items.at(state.treasuryTypes.items.length - 1).id);
                                            treasuryTypesReq.setNextto(wrapper)
                                            getFilterPromise = dispatch(getTreasuryTypes({ body: treasuryTypesReq, headers: getHeaders() }))
                                        }
                                    }}
                                    onSuggestionClick={(ev?, item?: any, index?: number) => {
                                        var u = state.treasuryTypes.items.findIndex(e => e.id == item.key)
                                        if (u >= 0) {
                                            dispatch(setSelectedTreasuryTypeItems([state.treasuryTypes.items.at(u)]))
                                        }

                                    }}
                                    isPeoplePicker={false}
                                    selectedItems={state.treasuryTypes.selected.length > 0 ? state.treasuryTypes.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                    onChange={(e) => {
                                        dispatch(setSelectedTreasuryTypeItems([]))

                                    }}
                                    onEmptyInputFocus={() => {
                                        dispatch(resetTreasuryTypes())
                                        treasuryTypesReq.setSearch(undefined)
                                        treasuryTypesReq.setNextto(undefined)
                                        dispatch(setIsFilteredTreasuryTypesSet(false))
                                        getFilterPromise?.abort()
                                        getFilterPromise = dispatch(getTreasuryTypes({ body: treasuryTypesReq, headers: getHeaders() }))
                                        return []
                                    }}
                                    onFilterChanged={onTreasuryTypesFilterChanged}
                                    endButtons={[
                                        {
                                            title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(100)

                                            }
                                        }]}
                                />

                            </Stack> : undefined}


                            {props.type == FormType.ADD ? <Stack>
                                <Label required disabled={state.isLoading}>{t("limitation")}</Label>
                                <List
                                    inputProps={{ placeholder: t("limitation"), required: true }}
                                    disabled={state.isLoading}
                                    suggestionsHeaderText={t('limitations')}
                                    isLoading={state.limitations.items.length == 0 ? state.limitations.isFetching : false}
                                    isSearching={state.limitations.items.length > 0 ? state.limitations.isFetching : false}
                                    moreSuggestionsAvailable={state.limitations.hasMore && !state.limitations.isFetching}
                                    suggestions={state.limitations.items.length > 0 ? state.limitations.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                    onGetMoreResults={() => {
                                        if (state.limitations.items.length > 0 && !state.limitations.isFetching) {
                                            const wrapper = new StringValue();
                                            wrapper.setValue(state.limitations.items.at(state.limitations.items.length - 1).id);
                                            limitationReq.setNextto(wrapper)
                                            getFilterPromise = dispatch(getLimitations({ body: limitationReq, headers: getHeaders() }))
                                        }
                                    }}
                                    onSuggestionClick={(ev?, item?: any, index?: number) => {
                                        var u = state.limitations.items.findIndex(e => e.id == item.key)
                                        if (u >= 0) {
                                            dispatch(setSelectedLimitationItems([state.limitations.items.at(u)]))
                                        }
                                    }}
                                    isPeoplePicker={false}
                                    selectedItems={state.limitations.selected.length > 0 ? state.limitations.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                    onChange={(e) => {
                                        dispatch(setSelectedLimitationItems([]))

                                    }}
                                    onEmptyInputFocus={() => {
                                        dispatch(resetLimitations())
                                        limitationReq.setSearch(undefined)
                                        limitationReq.setNextto(undefined)
                                        dispatch(setIsFilteredLimitationsSet(false))
                                        getFilterPromise?.abort()
                                        getFilterPromise = dispatch(getLimitations({ body: limitationReq, headers: getHeaders() }))
                                        return []
                                    }}
                                    onFilterChanged={onLimitationsFilterChanged}
                                    endButtons={[
                                        {
                                            title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(101)

                                            }
                                        }]}
                                />

                            </Stack> : undefined}


                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("extraFields") + ' '}
                                    <TooltipHost content={t("extraInformationDescription")}>
                                        <Icon iconName="Info" aria-label={t("extraFields")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <FieldArray
                                name="extraFields"
                                validateOnChange={false}

                            >
                                {arrayHelpers => {
                                    let r = [] as React.ReactNode[];
                                    if (formkikProps.values.extraFields && formkikProps.values.extraFields.length > 0) {
                                        r = formkikProps.values.extraFields.map((o, index) => {
                                            if (o.type == 1) {
                                                return (<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: props.childrenGap }} key={index}>
                                                    {o.label != undefined ? <Stack.Item grow> <DynamicInputField name={`extraFields[${index}].label`} placeholder={t("extraFieldLabel")} disabled={state.isLoading}
                                                        maxLength={50} autoFocus={(o as any)?.autoFocus} /> </Stack.Item> : null}
                                                    <Stack.Item grow>  <DynamicInputField name={`extraFields[${index}].value`} placeholder={t("extraFieldValue")} disabled={state.isLoading}
                                                        maxLength={50}
                                                    /></Stack.Item>

                                                    <IconButton disabled={state.isLoading}
                                                        iconProps={{ iconName: "remove" }} onClick={() => {
                                                            arrayHelpers.remove(index)
                                                        }} />
                                                </Stack>)
                                            }
                                        }
                                        )
                                    }
                                    if (formkikProps.values.extraFields.length <= 4) {
                                        r.push(< IconButton disabled={state.isLoading}
                                            key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {
                                                arrayHelpers.push({ key: (formkikProps.values.extraFields.length + 1) + "", label: "", type: 1, value: "", autoFocus: true })
                                            }} />)
                                    }
                                    return r;
                                }
                                }

                            </FieldArray>

                        </Stack>
                        <DialogFooter>
                            <PrimaryButton disabled={state.isLoading} text={state.isLoading ? undefined : props.type == FormType.ADD ? t("add") : t("edit")} type="submit" >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>

                    </Form>
                )}
            </Formik>
        </>
    );

}

